type ClassValue = string | number | boolean | undefined | null | ClassValue[];

/**
 * Простая утилита для объединения классов
 * Аналог clsx/cn
 */
export function cn(...classes: ClassValue[]): string {
  return classes
    .flat()
    .filter((x) => typeof x === 'string' && x.length > 0)
    .join(' ');
}
